import { configQuery, formatDate, toUtc, formatCurrency, FeatureEnabledV2, getItemDate, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __spreadArray, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';
import { TRANSACTIONS_NAMESPACE } from '../../store/modules/transactions/transactions.store.js';
import { store } from '../../store/index.js';
import { namespace } from 'vuex-class';
import { printContent } from '../../config/print-content.js';
import { BonusesTransactionColumn } from '@gig/magic-wallet-types';

var transactions = namespace(TRANSACTIONS_NAMESPACE);
var BonusesStatus;
(function (BonusesStatus) {
    BonusesStatus["CANCELLED"] = "Cancelled";
    BonusesStatus["CONSUMED"] = "Consumed";
    BonusesStatus["CONVERTED"] = "Converted";
    BonusesStatus["EXPIRED"] = "Expired";
    BonusesStatus["FULFILLED"] = "Fulfilled";
    BonusesStatus["FORFEITED"] = "Forfeited";
    BonusesStatus["REJECTED"] = "Rejected";
    BonusesStatus["AVAILABLE"] = "Available";
    BonusesStatus["ACTIVE"] = "Active";
})(BonusesStatus || (BonusesStatus = {}));
/**
 * Fetches and displays the list of bonuses
 * transactions
 */
var BonusesTransactionsComponent = /** @class */ (function (_super) {
    __extends(BonusesTransactionsComponent, _super);
    function BonusesTransactionsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Allow template to access this enum
        _this.Column = BonusesTransactionColumn;
        /**
         * When enabled it will show the time and date
         * in local time instead of UTC.
         */
        _this.isLocalTime = false;
        _this.size = _this.isAdvancedSearch ? 10 : 5;
        _this.limit = _this.isAdvancedSearch ? 10 : 5;
        _this.pageCount = 1;
        _this.allTransactions = [];
        /**
         * List of columns that should be displayed.
         * This property does not affect the order.
         */
        _this.columns = 'bonus-name,time,amount';
        /**
         * To show print link.
         */
        _this.showPrintBonusesHistory = false;
        return _this;
    }
    Object.defineProperty(BonusesTransactionsComponent.prototype, "hasMoreRows", {
        get: function () {
            return this.transactions.length >= this.limit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BonusesTransactionsComponent.prototype, "shownColumns", {
        get: function () {
            return this.columns.split(',').map(function (str) {
                return str.trim();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BonusesTransactionsComponent.prototype, "shownHistory", {
        get: function () {
            var _a;
            var filteredArr = ((_a = this.transactions) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
                return item.status !== BonusesStatus.AVAILABLE &&
                    item.status !== BonusesStatus.ACTIVE;
            }).map(function (item) {
                return {
                    id: item.id,
                    name: item.name,
                    date: item.createdOn,
                    amount: item.convertedAmount,
                    status: item.status,
                    currency: item.currencyCode,
                };
            })) || [];
            this.allTransactions = __spreadArray(__spreadArray([], this.allTransactions), filteredArr);
            return this.allTransactions;
        },
        enumerable: false,
        configurable: true
    });
    BonusesTransactionsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        configQuery('wallet.bonusHistoryPrintOption', function (bonusHistoryPrintOption) {
                            _this.showPrintBonusesHistory = bonusHistoryPrintOption;
                        });
                        configQuery('wallet.bonusHistoryColumns', function (bonusHistoryColumns) {
                            if (!bonusHistoryColumns) {
                                return;
                            }
                            _this.columns = bonusHistoryColumns.join(',');
                            _this.columnsValidator(_this.columns);
                        });
                        return [4 /*yield*/, this.fetchData(this.limit, this.pageCount)];
                    case 1:
                        _a.sent();
                        this.getOldestBonusTransactionDate();
                        return [2 /*return*/];
                }
            });
        });
    };
    BonusesTransactionsComponent.prototype.columnsValidator = function (columns) {
        var found = columns.split(',');
        var allValues = Object.values(BonusesTransactionColumn);
        return found.every(function (column) {
            return allValues.includes(column.trim());
        });
    };
    BonusesTransactionsComponent.prototype.isColumnShown = function (column) {
        return this.shownColumns.includes(column);
    };
    BonusesTransactionsComponent.prototype.loadMore = function () {
        this.size += this.limit;
        this.pageCount++;
        this.fetchData(this.limit, this.pageCount);
    };
    BonusesTransactionsComponent.prototype.fetchData = function (limit, pageCount) {
        return __awaiter(this, void 0, void 0, function () {
            var dateFrom, dateTo, isoStringFrom, isoStringTo, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.from || !this.to) {
                            return [2 /*return*/];
                        }
                        dateFrom = new Date(this.from);
                        dateTo = new Date(this.to);
                        isoStringFrom = dateFrom.toISOString();
                        isoStringTo = dateTo.toISOString();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.onContentLoadInit();
                        return [4 /*yield*/, this.fetchTransactions({
                                filter: "createdOn ge datetime'" + isoStringFrom + "' and createdOn le datetime'" + isoStringTo + "'",
                                limit: limit,
                                page: pageCount,
                            })];
                    case 2:
                        _a.sent();
                        this.onContentLoad(this.transactions);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.onContentLoadError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BonusesTransactionsComponent.prototype.getOldestBonusTransactionDate = function () {
        if (!this.transactions || this.transactions.length === 0) {
            return;
        }
        var oldestTransaction = new Date(this.shownHistory[0].date);
        this.$emit('update-from-date', oldestTransaction);
    };
    BonusesTransactionsComponent.prototype.printHistoryContent = function () {
        var rows = [];
        for (var _i = 0, _a = this.shownHistory; _i < _a.length; _i++) {
            var item = _a[_i];
            rows.push("\n                <tr>\n                    <td>" + item.name + "</td>\n                    <td>" + formatDate(toUtc(item.date)) + "</td>\n                    <td>" + formatCurrency(item.amount, item.currency) + "</td>\n                </tr>\n            ");
        }
        var content = "\n            <style>\n                table { border-collapse: collapse; width: 100%; }\n                th, td { border: 1px solid black; padding: 0.25em; text-align: left; }\n                button { border: 1px solid black; color: black; font-size: 32px; margin: 0 10px; }\n                div { margin: 50px 0; text-align: center; }\n                @media print { button { display: none; } }\n            </style>\n            <table>\n                <thead>\n                    <tr>\n                        <th>" + this.$t('bonuses-transactions.name.header') + "</th>\n                        <th>" + this.$t('bonuses-transactions.time.header') + "</th>\n                        <th>" + this.$t('bonuses-transactions.amount.header') + "</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    // " + rows.join('') + "\n                </tbody>\n            </table>\n        ";
        var buttons = "\n            <div>\n                <button onclick=\"window.print()\">" + this.$t('bonuses-transactions.print') + "</button>\n                <button onclick=\"window.close()\">" + this.$t('bonuses-transactions.close') + "</button>\n            </div>\n        ";
        printContent(content, buttons);
    };
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], BonusesTransactionsComponent.prototype, "from", void 0);
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], BonusesTransactionsComponent.prototype, "to", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], BonusesTransactionsComponent.prototype, "isAdvancedSearch", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TRANSACTIONS_HISTORY_ON_LOCAL_TIME,
        }),
        __metadata("design:type", Boolean)
    ], BonusesTransactionsComponent.prototype, "isLocalTime", void 0);
    __decorate([
        transactions.Getter('isLoadingState'),
        __metadata("design:type", void 0)
    ], BonusesTransactionsComponent.prototype, "isLoading", void 0);
    __decorate([
        transactions.Getter('getBonusesTransactions'),
        __metadata("design:type", void 0)
    ], BonusesTransactionsComponent.prototype, "transactions", void 0);
    __decorate([
        transactions.Action('fetchBonusesTransactions'),
        __metadata("design:type", Object)
    ], BonusesTransactionsComponent.prototype, "fetchTransactions", void 0);
    __decorate([
        Watch('from'),
        Watch('to'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Number]),
        __metadata("design:returntype", Promise)
    ], BonusesTransactionsComponent.prototype, "fetchData", null);
    BonusesTransactionsComponent = __decorate([
        Component({
            name: 'corex-bonuses-transactions',
            methods: { getItemDate: getItemDate },
            store: store,
            filters: {
                formatCurrency: formatCurrency,
                toUtc: toUtc,
                formatDate: formatDate,
            },
        })
    ], BonusesTransactionsComponent);
    return BonusesTransactionsComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default BonusesTransactionsComponent;
export { BonusesStatus };
